const normalizeIds = (ids = []) => [...new Set(ids)].sort();

export const contactPeopleKeys = {
	all: ['contactPeople'],
	byLeadIds: (leadIds) => ['contactPeople', 'byLeadIds', normalizeIds(leadIds)],
	byProspectQuery: (prospectQueryId) => ['contactPeople', 'byProspectQuery', prospectQueryId],
};

export const contactPeopleMutationKeys = {
	addToEmailList: ['contactPeople', 'addToEmailList'],
};
